import { useNavigate } from 'react-router-dom';

// Controls inside a row that do something of their own.
const INTERACTIVE = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  'label',
  '[role="button"]',
  '[role="checkbox"]',
  '[role="menuitem"]',
  '.ant-checkbox-wrapper',
  '.ant-dropdown-trigger',
  '.ant-select',
  '[data-row-click="ignore"]',
].join(',');

/**
 * `onRow` props that open a record when its row is clicked. A click on a
 * control in the row, inside a menu or modal opened from it (React bubbles
 * those through the row even though they render elsewhere), or that ends a
 * text selection does not count. Ctrl/Cmd + click opens a new tab.
 *
 * @param {(record: Object) => string} getUrl
 * @returns {(record: Object) => Object}
 */
export default function useRowOpen(getUrl) {
  const navigate = useNavigate();

  return (record) => ({
    onClick: (event) => {
      const row = event.currentTarget;
      if (!row.contains(event.target)) return;
      const control = event.target.closest(INTERACTIVE);
      if (control && row.contains(control)) return;
      const selection = window.getSelection();
      if (
        selection &&
        !selection.isCollapsed &&
        row.contains(selection.anchorNode)
      )
        return;

      const url = getUrl(record);
      if (event.ctrlKey || event.metaKey) {
        window.open(url, '_blank', 'noopener');
        return;
      }
      navigate(url);
    },
    className: 'cursor-pointer',
  });
}
